var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 63,
    viewBox: "0 0 411.751 324.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "factory",
    d: "M3026.248-10574.068v-18h12.328v-114.271l88.049-49.829,5.464-142.681h74.932l8.107,161.594,34.514-19.341,5.448-142.253h74.929l8.1,161.53,85.743-47.812v193.063H3438v18Zm379.617-18v-7.851h-211.03v7.851Zm-229.028,0v-38.11h-82.99v38.11Zm-100.991,0v-7.851h-19.27v7.851Zm330.019-25.849v-136.568l-123.231,68.718v-68.682L3160-10685.729v-68.644l-103.428,58.529v77.927h19.27v-30.26h118.989v30.26Zm-105.23-98.5,19.958-11.129-4.918-98h-45.381l-2.246,58.635,32.586-18.26Zm-122.632-.038,19.6-10.981-4.925-98.111h-45.381l-2.257,58.957,32.966-18.656Zm136.769-127.094-.442-8.8h-43.009l-.337,8.8Zm-123,0-.442-8.8H3148.32l-.337,8.8Zm121.656-26.806-.527-10.5h-40.487l-.4,10.5Zm-123,0-.527-10.5h-40.487l-.4,10.5Zm176.911,241.395v-34.268h18v34.268Zm-29,0v-34.268h18v34.268Zm-29,0v-34.268h18v34.268Zm-29,0v-34.268h18v34.268Zm-29,0v-34.268h18v34.268Zm-29,0v-34.268h18v34.268Zm-145.909-26.456v-18h118.423v18Z",
    transform: "translate(-3026.248 10898.849)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.6baa92a5.svg";
export { ForwardRef as ReactComponent };